import { Reducer } from "redux";

import { tupdate } from "@/mk2/helpers/types";
import infiniteList, {
    State as SearchState,
    initialState as infiniteInitialState,
} from "@/mk2/reducers/infiniteList";

import {
    FORUM_LIST_OF_GROUPS_FETCH_API_FAILURE,
    FORUM_LIST_OF_GROUPS_FETCH_API_REQUEST,
    FORUM_LIST_OF_GROUPS_FETCH_API_SUCCESS,
    FORUM_LIST_OF_GROUPS_FETCH_NEW_API_SUCCESS,
    FORUM_LIST_OF_GROUPS_SET_SELECTING_CATEGORY,
    ListOfGroupsFetchApiFailureAction,
    ListOfGroupsFetchApiRequestAction,
    ListOfGroupsFetchApiSuccessAction,
    ListOfGroupsFetchNewApiSuccessAction,
    ListOfGroupsSetSelectingCategoryAction,
} from "./ListOfGroups.actions";

type ListOfGroupsFetchActions =
    | ListOfGroupsFetchApiRequestAction
    | ListOfGroupsFetchApiSuccessAction
    | ListOfGroupsFetchApiFailureAction;

export interface GroupsSearchState extends SearchState {
    count: number;
}

export const initialQueryState: GroupsSearchState = {
    ...infiniteInitialState,
    count: 0,
};

const searchReducer: Reducer<GroupsSearchState> = (
    state: GroupsSearchState = initialQueryState,
    action: ListOfGroupsFetchActions,
) => {
    return tupdate(state, {
        ...infiniteList("FORUM_LIST_OF_GROUPS_FETCH_API", (a) => a.response.result.groups)(
            state,
            action,
        ),
        count: action.type === FORUM_LIST_OF_GROUPS_FETCH_API_SUCCESS ? action.count : state.count,
    });
};

export interface GroupsCategoryState {
    [query: string]: GroupsSearchState;
}

export const initialGroupsCategoryState = {};

const categoryReducer: Reducer<GroupsCategoryState> = (
    state: GroupsCategoryState = initialGroupsCategoryState,
    action: ListOfGroupsFetchActions,
) => {
    return tupdate(state, {
        [action.query]: searchReducer(state[action.query], action),
    });
};

export interface ListOfGroupsPageState {
    searches: {
        [category: string]: GroupsCategoryState;
    };
    hasMoreNewGroups: boolean;
    newGroupsIds: number[];
    selectingCategory: boolean;
}

export const initialListOfGroupsPageState: ListOfGroupsPageState = {
    searches: {},
    hasMoreNewGroups: false,
    newGroupsIds: [],
    selectingCategory: false,
};

type ListOfGroupsPageActions =
    | ListOfGroupsFetchActions
    | ListOfGroupsFetchNewApiSuccessAction
    | ListOfGroupsSetSelectingCategoryAction;

const listOfGroupsPageReducer: Reducer<ListOfGroupsPageState> = (
    state: ListOfGroupsPageState = initialListOfGroupsPageState,
    action: ListOfGroupsPageActions,
) => {
    switch (action.type) {
        case FORUM_LIST_OF_GROUPS_FETCH_API_REQUEST:
        case FORUM_LIST_OF_GROUPS_FETCH_API_FAILURE:
            return tupdate(state, {
                searches: tupdate(state.searches, {
                    [action.category]: categoryReducer(state.searches[action.category], action),
                }),
            });

        case FORUM_LIST_OF_GROUPS_FETCH_API_SUCCESS:
            return tupdate(state, {
                // there are always more new groups on the initial load
                hasMoreNewGroups: action.after ? state.hasMoreNewGroups : true,
                newGroupsIds: action.after // don't touch newGroupIds on subsequent onLoad actions
                    ? state.newGroupsIds
                    : action.response.result.newGroups,
                searches: tupdate(state.searches, {
                    [action.category]: categoryReducer(state.searches[action.category], action),
                }),
            });

        case FORUM_LIST_OF_GROUPS_FETCH_NEW_API_SUCCESS:
            return tupdate(state, {
                hasMoreNewGroups: action.hasMore,
                newGroupsIds: [...state.newGroupsIds, ...action.response.result.newGroups],
            });

        case FORUM_LIST_OF_GROUPS_SET_SELECTING_CATEGORY:
            return tupdate(state, {
                selectingCategory: action.selecting,
            });

        default:
            return state;
    }
};

export default listOfGroupsPageReducer;
